module.exports = __webpack_public_path__ + "mainassets/img/info.8886d75d.svg";